<template>
    <div class="stepper">
        <div class="stepper__container">
            <div class="stepper__track" />
            <div
                v-for="(step, idx) in steps"
                :key="idx"
                class="stepper__item"
                :class="{
                    'stepper__item--completed': checkedSteps.includes(idx),
                    'stepper__item--active': idx === activeStep && !checkedSteps.includes(idx)
                }"
            >
                <div class="stepper__circle">
                    <img
                        v-if="checkedSteps.includes(idx)"
                        src="@/assets/img/icons/check-bold.svg"
                        alt="check"
                        class="stepper__check"
                    />
                    <span v-else-if="idx === activeStep" class="stepper__circle-inner" />
                </div>
                <div class="stepper__item-title" :class="{ 'stepper__item-title--active': idx === activeStep }">
                    {{ $ml.get(step) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	props: {
		activeStep: {
			type: Number,
			default: 1
		},
		steps: {
			type: Array,
			default: () => ['stepperText1', 'stepperText2', 'stepperText3']
		},
		checkedSteps: {
        type: Array,
        default: () => []
    }
	},
	methods: {
		translate(key) {
			return this.$ml ? this.$ml.get(key) : key;
		}
	}
};
</script>

<style lang="scss" scoped>
	.stepper {
		width: 100%;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: flex-start;

		&__container {
			width: 100%;
			max-width: 400px;
			display: flex;
			justify-content: center;
		}

		&__track {
			width: 100%;
			max-width: 250px;
			height: 2px;
			position: absolute;
			top: 12px;
			background: #DBE0E5;
			z-index: 0;
		}

		&__item {
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: center;
			flex: 1;
			z-index: 1;

			&-title {
				color: #5C6A7B;
				font-size: 14px;
				font-weight: 500;
				margin-top: 8px;
				transition: font-weight 0.3s;

				&--active {
					font-weight: 700;
				}
			}

			&--active .stepper__circle {
				background: #0774E7;
				border-color: #0774E7;
				color: #fff;
			}

			&--completed .stepper__circle {
				background: #0774E7;
				border-color: #0774E7;
				color: #fff;
			}
		}

		&__circle {
			width: 25px;
			height: 25px;
			border-radius: 50%;
			background: #DBE0E5;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 20px;
			color: #fff;
			margin-bottom: 8px;
			border: 2px solid #DBE0E5;
			transition: background 0.3s, border 0.3s;

			&-inner {
				width: 16px;
				height: 16px;
				border-radius: 50%;
				background: #5C6A7B;
				display: block;
			}
		}

		.stepper__item--active .stepper__circle {
			background: #DBE0E5;
			border-color: #DBE0E5;
			color: #fff;
		}
	}
</style>
